export const SupplyKeys = {
  allSupplies: ['Supplies'] as const,
  listSupplies: () => [...SupplyKeys.allSupplies, 'listSupplies'] as const,
  listSupply: () => [...SupplyKeys.listSupplies(), {}] as const,
}
